import { Modal } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/DeviceType/DeviceTypeModel';
import { RootState } from '../../../store';
import DeviceForm from '../DeviceForm/DeviceForm';

const DeviceModal: React.FC<any> = () => {
  const dispatch = useDispatch();
  const reduxDevice = useSelector((state: RootState) => state.models.deviceType);

  return (
    <Modal
      title={!!reduxDevice.id ? 'Modifica' : 'Adauga'}
      open={reduxDevice.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <DeviceForm />
    </Modal>
  );
};

export default DeviceModal;
